import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary text-white py-8 md:py-12 mt-0">
      <div className="container mx-auto px-4 text-center">
        <p className="text-xl md:text-2xl mb-3">
          🧡{' '}
          <span className="text-red-500">A</span>
          <span className="text-orange-500">Z</span>
          <span className="text-yellow-400">O</span>
          <span className="text-green-500">C</span>
          <span className="text-blue-500">S</span>
          <span className="text-indigo-500">I</span>
          <span className="text-purple-500">I</span>
          {' '}- 돈까스 아조씨
        </p>
        <p className="text-sm md:text-base text-gray-300 mb-2">
          © 2026 AZOCSII Project.
        </p>
        <p className="text-xs text-secondary mb-3">
          <span className="font-bold text-accent">A</span>uthentic{' '}
          <span className="font-bold text-accent">Z</span>eal{' '}
          <span className="font-bold text-accent">O</span>asis —{' '}
          <span className="font-bold text-accent">C</span>ounselor{' '}
          <span className="font-bold text-accent">S</span>olidarity{' '}
          <span className="font-bold text-accent">I</span>nitiative{' '}
          <span className="font-bold text-accent">I</span>mpact
        </p>
        <p className="text-xs md:text-sm text-gray-400 mt-3">
          소명: 일상 회복 | A to Z, For Every Humanist in the World
        </p>
        <div className="mt-3 text-xs text-gray-400">
          <Link
            to="/privacy"
            className="hover:text-gray-200 underline underline-offset-2"
          >
            개인정보 처리방침
          </Link>
          <span className="mx-2">|</span>
          <Link
            to="/terms"
            className="hover:text-gray-200 underline underline-offset-2"
          >
            이용약관
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
